import React, { useState, useEffect, useCallback } from 'react';
import './galleryModal.scss'; // We'll create this file next

// interface ProjectImage { imageUrl: string; altText: string; }
// interface Project { id: any; images: ProjectImage[]; title?: string; /* ... other fields */ }
// interface ModalProps {
//   isOpen: boolean;
//   onClose: () => void;
//   project: Project | null;
// }

const GalleryModal = ({ isOpen, onClose, project }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Reset index when project changes or modal opens
  useEffect(() => {
    if (project) {
      setCurrentIndex(0); // Start at the first image when modal opens for a project
    }
  }, [project]);

  const handleNext = useCallback(() => {
    if (!project || project.images.length <= 1) return;
    setCurrentIndex((prevIndex) => (prevIndex + 1) % project.images.length);
  }, [project]);

  const handlePrev = useCallback(() => {
    if (!project || project.images.length <= 1) return;
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? project.images.length - 1 : prevIndex - 1
    );
  }, [project]);

  // Keyboard navigation (Arrows and Escape)
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === 'ArrowRight') {
        handleNext();
      } else if (event.key === 'ArrowLeft') {
        handlePrev();
      } else if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    // Cleanup listener on component unmount or when modal closes
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, handleNext, handlePrev, onClose]);


  // Don't render if not open or no project data
  if (!isOpen || !project) {
    return null;
  }

  const currentImage = project.images[currentIndex];
  const showNavigation = project.images.length > 1;

  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      {/* Stop propagation prevents closing modal when clicking content */}
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button
          className="modal-close-btn"
          onClick={onClose}
          aria-label="Close modal"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        {/* Project Title at Top */}
        <div className="modal-header">
          {project.title && <h2 className="modal-title">{project.title}</h2>}
          {showNavigation && (
            <div className="modal-counter">
              <span>{currentIndex + 1}</span>
              <span className="counter-separator">/</span>
              <span>{project.images.length}</span>
            </div>
          )}
        </div>

        {/* Images in Middle */}
        <div className="modal-image-container">
          {showNavigation && (
            <button
              className="modal-nav-btn modal-prev-btn"
              onClick={handlePrev}
              aria-label="Previous image"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
          )}

          {currentImage ? (
             <img
               src={currentImage.imageUrl}
               alt={currentImage.altText}
               className="modal-image"
             />
          ) : (
            <p className="modal-image-fallback">Image not available.</p>
          )}

          {showNavigation && (
            <button
              className="modal-nav-btn modal-next-btn"
              onClick={handleNext}
              aria-label="Next image"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          )}
        </div>

        {/* Description Below Images */}
        <div className="modal-description">
          {project.description && (
            <p className="modal-description-text">{project.description}</p>
           )}
        </div>

      </div>
    </div>
  );
};

export default GalleryModal;